export const SWITCH_WIDTH = 34;
export const SWITCH_HEIGHT = 20;
export const SWITCH_BASE_MARGIN = 2;
export const THUMB_SIZE = 16;
